export const SIGN_NEW_AGREEMENT_PATH = `sign-new-agreement`;
